/**
 * GoHighLevel CRM adapter — REAL para resolveContact únicamente.
 *
 * El resto de CRMPort (connect/syncActors/syncSignals/pushOutcome) sigue
 * sin implementarse — no se ha necesitado hasta ahora, y expandir ese
 * alcance no es parte del bloque de vinculación automática de contactos
 * (Sprint 11 noche). Ver TRUST_BOUNDARY.md: nunca llama a GHL directamente
 * ni conoce el PIT — llama a la ruta relativa /api/crm/resolve-contact,
 * que en dev resuelve el proxy de craco.config.js y en producción resuelve
 * al mismo backend que sirve el build (mismo origen).
 */
export function createGhlCRM() {
  const err = () => { throw new Error("GHL_ADAPTER_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "ghl" }; },
    async connect() { err(); },
    async disconnect() { err(); },
    async syncActors() { err(); },
    async syncSignals() { err(); },
    async pushOutcome() { err(); },
    async pushActorUpdate() { err(); },
    subscribeToSignals() { return () => {}; },

    async resolveContact({ phone, email } = {}) {
      try {
        const res = await fetch("/api/crm/resolve-contact", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone, email }),
        });
        if (!res.ok) {
          return { status: "not_found", contactId: null, candidates: [] };
        }
        return await res.json();
      } catch (e) {
        return { status: "not_found", contactId: null, candidates: [] };
      }
    },
  };
}
